/* tslint:disable */
/* eslint-disable */
/**
 * Properties API
 * API for managing properties
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { QuestionAnswerDto } from './QuestionAnswerDto';
import {
    QuestionAnswerDtoFromJSON,
    QuestionAnswerDtoFromJSONTyped,
    QuestionAnswerDtoToJSON,
    QuestionAnswerDtoToJSONTyped,
} from './QuestionAnswerDto';

/**
 * 
 * @export
 * @interface SaveAnswerCommandDto
 */
export interface SaveAnswerCommandDto {
    /**
     * List of question responses
     * @type {Array<QuestionAnswerDto>}
     * @memberof SaveAnswerCommandDto
     */
    answers: Array<QuestionAnswerDto>;
    /**
     * Unique identifier of the survey/questionnaire
     * @type {string}
     * @memberof SaveAnswerCommandDto
     */
    surveyId: string;
    /**
     * Whether to automatically evaluate the responses
     * @type {boolean}
     * @memberof SaveAnswerCommandDto
     */
    autoEvaluate?: boolean;
}

/**
 * Check if a given object implements the SaveAnswerCommandDto interface.
 */
export function instanceOfSaveAnswerCommandDto(value: object): value is SaveAnswerCommandDto {
    if (!('answers' in value) || value['answers'] === undefined) return false;
    if (!('surveyId' in value) || value['surveyId'] === undefined) return false;
    return true;
}

export function SaveAnswerCommandDtoFromJSON(json: any): SaveAnswerCommandDto {
    return SaveAnswerCommandDtoFromJSONTyped(json, false);
}

export function SaveAnswerCommandDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SaveAnswerCommandDto {
    if (json == null) {
        return json;
    }
    return {
        
        'answers': ((json['answers'] as Array<any>).map(QuestionAnswerDtoFromJSON)),
        'surveyId': json['surveyId'],
        'autoEvaluate': json['autoEvaluate'] == null ? undefined : json['autoEvaluate'],
    };
}

export function SaveAnswerCommandDtoToJSON(json: any): SaveAnswerCommandDto {
    return SaveAnswerCommandDtoToJSONTyped(json, false);
}

export function SaveAnswerCommandDtoToJSONTyped(value?: SaveAnswerCommandDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'answers': ((value['answers'] as Array<any>).map(QuestionAnswerDtoToJSON)),
        'surveyId': value['surveyId'],
        'autoEvaluate': value['autoEvaluate'],
    };
}

